<div class="grid gap-4 w-full">

  @if (!isCartOverview()) {
    <webmodule-order-alert [title]="'block.cart.support.title' | translate">{{ 'block.cart.support.description' | translate }}</webmodule-order-alert>
  }

  <webmodule-order-panel>
    <ng-container heading>
      <h3 class="mb-0">{{ 'block.cart.heading' | translate }}</h3>
    </ng-container>
    <ng-container content>
      <div class="cart">
        @if (cartState().size === 0) {
          <section>
            <div class="h-6 w-32 bg-gray-100 rounded-sm h6"></div>
            <div class="line">
              <div class="h-4 w-48 bg-gray-100 rounded-sm"></div>
              <div class="h-4 w-24 bg-gray-100 rounded-sm ml-auto"></div>
            </div>
            <div class="line">
              <div class="h-4 w-32 bg-gray-100 rounded-sm"></div>
              <div class="h-4 w-16 bg-gray-100 rounded-sm ml-auto"></div>
            </div>
            <div class="line">
              <div class="h-4 w-36 bg-gray-100 rounded-sm"></div>
              <div class="h-4 w-16 bg-gray-100 rounded-sm ml-auto"></div>
            </div>
          </section>
          <section class="border-gray-200">
            <div class="h-6 w-32 bg-gray-100 rounded-sm h6"></div>
            <div class="line">
              <div class="h-4 w-48 bg-gray-100 rounded-sm"></div>
              <div class="h-4 w-24 bg-gray-100 rounded-sm ml-auto"></div>
            </div>
          </section>
        } @else {
          @if (cartState().get('internet'); as cartLine) {
            <section>
              <h6 [innerHTML]="'block.cart.internet.title' | translate" class="[&_*]:mb-0"></h6>
              <div class="line">
                <span class="font-semibold">{{ cartLine.name }}</span>
                <span class="price">{{ cartLine.priceAsNumber | currency: 'EUR' }}</span>
              </div>
            </section>
          }

          @if (!internetOnly()) {
            @if (cartState().get('itv'); as cartLine) {
              <section>
              <h6 [innerHTML]="'block.cart.television.title' | translate" class="[&_*]:mb-0"></h6>
                <div class="line">
                  <span class="font-semibold">{{ cartLine.name }}</span>
                  <span class="price">{{ cartLine.price ? (cartLine.price | currency: 'EUR') : '' }}</span>
                </div>

                @if (cartState().get('itvBoxType'); as cartLine) {
                  <div class="line">

                    <ng-container [ngTemplateOutlet]="templateCardLine"
                                  [ngTemplateOutletContext]="{ $implicit: cartLine }"></ng-container>
                  </div>
                }
                @if (cartState().get('itvBox'); as cartLine) {
                  @if (number(cartLine.value) >= 1) {
                    <div class="line">
                      <span class="text-sm">
                        @if (number(cartLine.value) > 1) {
                          {{ cartLine.value }}x
                        }

                        {{ cartLine.label ?? cartLine.name }}

                        @if (cartLine.price && !cartLine.isPartOfPackage) {
                          <span class="text-xs">({{ 'oneTime' === camelCase(cartLine.paymentFrequency) ? 'eenmalig' : 'per maand' }})</span>
                        }
                      </span>
                      <span class="price">
                        @if (cartLine.isPartOfPackage) {
                          {{ 'common.label.included' | translate }}
                        } @else {
                          @if (cartLine.price) {
                            {{ (cartLine.price * (isNaN(cartLine.value) ? 1 : cartLine.value)) | currency: 'EUR' }}
                          }
                        }
                      </span>
<!--                      <ng-container [ngTemplateOutlet]="templateCardLine"-->
<!--                                    [ngTemplateOutletContext]="{ $implicit: cartLine }"></ng-container>-->
                    </div>
                  }
                }
                @if (cartState().get('tvOptions'); as cartLine) {
                  @if (!isCartOverview()) {
                    <button (click)="toggleTvOptions()" class="button sm link">
                      {{ 'block.cart.button.show-tv-options' | translate }}
                    </button>
                  }

                  @if(showAllTvOptions()) {
                    @for (option of cartLine; track option) {
                      <div class="line">
                        <ng-container [ngTemplateOutlet]="templateCardLine"
                                      [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>
                      </div>
                    }
                  }
                }
              </section>
            }
          }
          @if (cartState().get('landline'); as cartLine) {
            <section>
              <h6 [innerHTML]="'block.cart.phone.title' | translate" class="[&_*]:mb-0"></h6>
              <div class="line">
                <span class="font-semibold">{{ cartLine.name }}</span>
                <span class="price">{{ cartLine.price ? (cartLine.price | currency: 'EUR') : '' }}</span>
              </div>

              @if (cartState().get('numberPorting'); as cartLine) {
                <div class="line pl-2">
                  <ng-container [ngTemplateOutlet]="templateCardLine"
                                [ngTemplateOutletContext]="{ $implicit: cartLine }"></ng-container>
                </div>
              }

              @if (cartState().get('phoneUnlimited'); as cartLine) {
                <div class="line">
                  <ng-container [ngTemplateOutlet]="templateCardLine"
                                [ngTemplateOutletContext]="{ $implicit: cartLine }"></ng-container>
                </div>
              }

              @if (cartState().get('extraPhoneLine'); as cartLine) {
                <div class="line">
                  <ng-container [ngTemplateOutlet]="templateCardLine"
                                [ngTemplateOutletContext]="{ $implicit: cartLine }"></ng-container>
                </div>

                @if (cartState().get('extraNumberPorting'); as cartLine) {
                  <div class="line pl-4">
                    <ng-container [ngTemplateOutlet]="templateCardLine"
                                  [ngTemplateOutletContext]="{ $implicit: cartLine }"></ng-container>
                  </div>
                }
              }
            </section>
          }
          @if (cartState().get('mobile'); as cartLine) {
            <section>
              <h6 [innerHTML]="'block.cart.mobile.title' | translate" class="[&_*]:mb-0"></h6>
              <div class="line">
                <span class="font-semibold">{{ cartLine.name }}</span>
                <span class="price">
                  {{ cartLine.id === 'DATA_NONE' ? '' : (cartLine.price | currency: 'EUR') }}</span>
              </div>
            </section>
          }
        }

      </div>


      <section class="-mx-4 mt-4">
        <div class="flex justify-between gap-2 text-xl bg-secondary bg-opacity-60 text-white p-4">
          <span class="font-semibold">{{ 'cart.label.total-monthly' | translate }}</span>
          <span class="price font-semibold">
            {{ totalRecurringCost() | currency: 'EUR'}}
          </span>
        </div>
        <div class="flex justify-between gap-2 pt-4 px-4">
          <span class="font-semibold">{{ 'cart.label.total-one-time' | translate }}</span>
          <span class="price">
            {{ totalOneTimeCost() | currency: 'EUR'}}
          </span>
        </div>

        <div class="mt-4 border-t border-dashed border-primary"></div>
        <span class="text-xs px-4 py-2"><em>{{ 'cart.label.prices-including-tax' | translate }}</em></span>
      </section>
    </ng-container>
    @if(!isCartOverview()) {
     <ng-container footer>
        @if (uiState() === 'CONFIG') {
          <button [disabled]="!canOrder()"
                  (click)="addDetails()"
                  class="button secondary w-full"
                  type="button">
            {{ 'block.cart.button.continue-order' | translate}}
          </button>
        }

        @if (uiState() === 'DETAILS') {
          <div class="flex justify-between gap-2">
            <button [disabled]="!canFinalizeOrder() || pendingRequest()"
                    (click)="completeOrder()"
                    class="button secondary"
                    type="button">
              {{ 'block.cart.button.continue-order' | translate }}
            </button>
            <button (click)="editOrder()"
                    [disabled]="pendingRequest()"
                    class="link"
                    type="button">
              {{ 'block.cart.button.change-order' | translate }}
            </button>
          </div>
        }
      </ng-container>
    }
  </webmodule-order-panel>

  @if (false) {
    <webmodule-order-panel >
      <ng-container heading>
        <h3 class="mb-0">Dit krijg je thuis</h3>
      </ng-container>
      <ng-container content>
        <p>panel-television works!</p>
      </ng-container>
    </webmodule-order-panel>
  }

  <ng-template #templateCardLine let-line>
    <span class="text-sm">
      <span [innerHTML]="line.label ?? line.name"></span>

      @if (line.price && !line.isPartOfPackage) {
        <span class="text-xs">({{ 'oneTime' === camelCase(line.paymentFrequency) ? 'eenmalig' : 'per maand' }})</span>
      }
    </span>
    <span class="price">
      @if (line.isPartOfPackage) {
        {{ 'common.label.included' | translate }}
      } @else {
        @if (line.price) {
          {{ (line.price * (isNaN(line.value) ? 1 : line.value)) | currency: 'EUR' }}
        }
      }
    </span>
  </ng-template>
</div>
